import { RockyChatAnswers } from '@modules/HappinessModule/pages/ChatPage/enums/RockyChatAnswers';

export const getMessageByMark = (mark: number): RockyChatAnswers => {
  return mark < 7 ? RockyChatAnswers.Low : mark >= 7 && mark < 9 ? RockyChatAnswers.Average : RockyChatAnswers.High;
};
